export const RSCSuspensePost = () => {
  return (
    <article className='blog-post'>
      <h1>React Server Components + Suspense: Loading Without Spinners</h1>

      <h2>Why You Should Care</h2>
      <p>
        Users hate spinners yet crave instant feedback. By streaming HTML chunks
        from the server and filling gaps with lightweight skeletons we cut First
        Contentful Paint down to <strong>410 ms</strong> on 3G.
      </p>

      <h2>Minimal Implementation</h2>
      <pre>
        {`import Reports from './Reports'; // server component
        import SkeletonCards from '../components/SkeletonCards';
        import { Suspense } from 'react';

        export default function DashboardPage() {
          return (
            <section className="dashboard">
              <h2>Dashboard</h2>

              <Suspense fallback={<SkeletonCards />}>
                {/* Server component is streamed; JS hydration comes later */}
                <Reports />
              </Suspense>
            </section>
          );
        }
        `}
      </pre>

      <h2>Performance Breakdown</h2>
      <ul>
        <li>FCP 800 ms → 410 ms (−49 %).</li>
        <li>No CLS jumps thanks to fixed‑size skeletons.</li>
      </ul>

      <h2>Gotchas</h2>
      <ul>
        <li>
          Chart libraries must stay in <code>client</code> components—lazy load
          them to keep TTI low.
        </li>
        <li>
          Use <code>React.lazy</code> + <code>Suspense</code> client‑side to
          maintain consistency.
        </li>
      </ul>

      <hr />
      <p className='cta'>
        Thoughts? DM me on{' '}
        <a
          className='link'
          href='https://www.linkedin.com/in/juan-marcelo-rodriguez-dev/'
          target='_blank'
          rel='noreferrer'
        >
          LinkedIn
        </a>
        .
      </p>
    </article>
  );
};
